import type { PaidRefundCandidate, PaidRefundRequest, PaidRefundResult } from 'shared-models/browser';
import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';

const url = (tenantId: string, orderId: number) =>
  `/payments/tenant/${tenantId}/orders/${orderId}/refund`;

export const paidOrderRefundsService = {
  async voidFailed(tenantId: string, orderId: number, employeeSession: string): Promise<void> {
    try {
      await authenticatedInstance.post(`${url(tenantId, orderId)}/void-failed`, { confirmedFailed: true },
        { headers: { 'x-employee-session': employeeSession } });
    } catch (error) {
      throw new Error(extractServiceErrorMessage(error, 'REFUND_VOID_FAILED'));
    }
  },
  async candidates(tenantId: string, orderId: number, employeeSession: string): Promise<PaidRefundCandidate[]> {
    const response = await authenticatedInstance.get<PaidRefundCandidate[]>(`${url(tenantId, orderId)}/candidates`,
      { headers: { 'x-employee-session': employeeSession } });
    return response.data;
  },
  async refund(tenantId: string, orderId: number, employeeSession: string,
    request: PaidRefundRequest): Promise<PaidRefundResult> {
    try {
      const response = await authenticatedInstance.post<PaidRefundResult>(url(tenantId, orderId), request,
        { headers: { 'x-employee-session': employeeSession } });
      return response.data;
    } catch (error) {
      const data = (error as { response?: { data?: { message?: unknown; deliveryTargetLabel?: string } } }).response?.data;
      if (data?.message === 'REFUND_2FA_REQUIRED') {
        throw Object.assign(new Error('REFUND_2FA_REQUIRED'), { deliveryTargetLabel: data.deliveryTargetLabel });
      }
      throw new Error(extractServiceErrorMessage(error, 'REFUND_FAILED'));
    }
  },
};